module.exports = __webpack_public_path__ + "static/media/chat.afce8b05.png";